import { render, staticRenderFns } from "./Collaborate-with.vue?vue&type=template&id=3b2283c7&scoped=true"
var script = {}
import style0 from "./Collaborate-with.vue?vue&type=style&index=0&id=3b2283c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2283c7",
  null
  
)

export default component.exports